// Vendor libraries
import { ChangeDetectorRef, ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
// Services
import { NewsAIService } from 'NewsApp/services/news-ai.service';
import * as i0 from "@angular/core";
import * as i1 from "NewsApp/services/news-ai.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i5 from "SecuritiesApp/ts/features/news-ai-chat/news-ai-response.component";
function NewsAIChatComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "ycn-loading-symbol", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function NewsAIChatComponent_ng_template_1_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 18);
    i0.ɵɵelement(4, "div", 19)(5, "div", 20);
    i0.ɵɵpipe(6, "date");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const chatMessage_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-ai-q");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", chatMessage_r2.message);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(6, 3, chatMessage_r2.time, "MMM. d, yyyy h:mm a"));
} }
function NewsAIChatComponent_ng_template_1_ng_container_1_ycn_news_ai_response_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-news-ai-response", 21);
} if (rf & 2) {
    const chatMessage_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("chatMessage", chatMessage_r2);
} }
function NewsAIChatComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 12);
    i0.ɵɵtemplate(1, NewsAIChatComponent_ng_template_1_ng_container_1_div_1_Template, 7, 6, "div", 13)(2, NewsAIChatComponent_ng_template_1_ng_container_1_ycn_news_ai_response_2_Template, 1, 1, "ycn-news-ai-response", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const chatMessage_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngSwitch", chatMessage_r2.role);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "user");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "ai");
} }
function NewsAIChatComponent_ng_template_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵlistener("click", function NewsAIChatComponent_ng_template_1_div_6_Template_div_click_0_listener() { const choice_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.submitQuery(choice_r4)); });
    i0.ɵɵelement(1, "span", 23);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const choice_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", choice_r4.display_query || choice_r4.query);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-send");
} }
function NewsAIChatComponent_ng_template_1_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "Please note that the YCharts AI news chat module is designed to summarize a security's recent market news and should not be considered financial advice. Here are some important details about the chat module:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul")(4, "li");
    i0.ɵɵtext(5, "We only consider news articles related to the query from the past 20 days.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "li");
    i0.ɵɵtext(7, "We select the top 10 relevant articles based on OpenAI's embedding model. You can view the sources used to generate the prompt.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "li");
    i0.ɵɵtext(9, "Query choices will depend on news availability and relevancy.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li");
    i0.ɵɵtext(11, "Each message sent is isolated and not related to any previous messages.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "li");
    i0.ɵɵtext(13, "The AI-generated news summary will consist of at most three paragraphs and be less than 500 words.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "li");
    i0.ɵɵtext(15, "AI news chat is currently only available for S&P 500 and Nasdaq 100 stocks.");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} }
function NewsAIChatComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, NewsAIChatComponent_ng_template_1_ng_container_1_Template, 3, 3, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 5)(3, "div", 6);
    i0.ɵɵtext(4, "Select a query for news summary:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtemplate(6, NewsAIChatComponent_ng_template_1_div_6_Template, 3, 2, "div", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 9)(8, "a", 10);
    i0.ɵɵlistener("click", function NewsAIChatComponent_ng_template_1_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r1); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.toggleDisclosure()); });
    i0.ɵɵtext(9, "AI disclosure statement and information");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, NewsAIChatComponent_ng_template_1_ng_container_10_Template, 16, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.chatHistory);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r4.queryChoices);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.showDisclosure);
} }
/**
 * News AI Chat Component
 *
 * Represents a chat interaction between a user and AI about recent news.
 */
export class NewsAIChatComponent {
    get backgroundClass() {
        return !this.loading;
    }
    constructor(changeDetector, el, newsAIService) {
        this.changeDetector = changeDetector;
        this.el = el;
        this.newsAIService = newsAIService;
        this.securityId = '';
        this.securityName = '';
        this.queryChoices = [];
        this.chatHistory = [];
        this.showDisclosure = false;
        this.loading = true;
        this.securityId = el.nativeElement.getAttribute('securityId');
        this.securityName = el.nativeElement.getAttribute('securityName');
    }
    ngOnInit() {
        this.newsAIService
            .getQueryChoices(this.securityId)
            .pipe(finalize(() => {
            this.loading = false;
        }))
            .subscribe({
            next: (queryChoices) => {
                this.queryChoices = queryChoices;
            },
            error: () => { },
        });
        this.chatHistory = [
            {
                role: 'ai',
                message: `Ask a question about ${this.securityName} (${this.securityId}).`,
                time: new Date(),
            },
        ];
    }
    submitQuery(choice) {
        this.chatHistory.push({
            role: 'user',
            message: choice.display_query ?? choice.query,
            time: new Date(),
        });
        this.chatHistory.push({
            role: 'ai',
            message: '',
            query: choice.query,
            security_id: choice.security_id,
            time: new Date(),
        });
    }
    toggleDisclosure() {
        this.showDisclosure = !this.showDisclosure;
        if (this.showDisclosure) {
            this.changeDetector.detectChanges();
            this.el.nativeElement.scrollTop = this.el.nativeElement.scrollHeight;
        }
    }
}
NewsAIChatComponent.ɵfac = function NewsAIChatComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NewsAIChatComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.NewsAIService)); };
NewsAIChatComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NewsAIChatComponent, selectors: [["ycn-news-ai-chat"]], hostVars: 2, hostBindings: function NewsAIChatComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("bg-gray-base-95", ctx.backgroundClass);
    } }, standalone: false, decls: 3, vars: 2, consts: [["showNewsAI", ""], [4, "ngIf", "ngIfElse"], [3, "loaderMessage"], [1, "ai-modules"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], [1, "ai-queries"], [1, "ai-queries-header"], [1, "ai-queries-list"], ["class", "ai-queries-list-item", "data-test-id", "news-ai-query-choice", 3, "click", 4, "ngFor", "ngForOf"], [1, "ai-footer"], ["href", "javascript:void(0)", 1, "collapse-toggler", 3, "click"], [4, "ngIf"], [3, "ngSwitch"], ["class", "ai-module ai-module-q", 4, "ngSwitchCase"], ["class", "ai-module ai-module-a", 3, "chatMessage", 4, "ngSwitchCase"], [1, "ai-module", "ai-module-q"], [1, "ai-module-icon"], ["ycnIcon", "", "role", "img", 3, "name"], [1, "ai-module-content"], [1, "ai-module-title", 3, "textContent"], [1, "panel-date", "pt-0", 3, "textContent"], [1, "ai-module", "ai-module-a", 3, "chatMessage"], ["data-test-id", "news-ai-query-choice", 1, "ai-queries-list-item", 3, "click"], [3, "textContent"]], template: function NewsAIChatComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NewsAIChatComponent_ng_container_0_Template, 2, 1, "ng-container", 1)(1, NewsAIChatComponent_ng_template_1_Template, 11, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const showNewsAI_r6 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.loading)("ngIfElse", showNewsAI_r6);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, i3.IconDirective, i4.LoadingSymbolComponent, i5.NewsAIResponseComponent, i2.DatePipe], encapsulation: 2 });
